import BreadCrumb from 'components/BreadCrumb/BreadCrumb';
import React from 'react';

export const BasicPageContainer = ({ children }) => (
  <>
    <BreadCrumb />
    {children}
  </>
);